(() => {
  const ROOT = '[data-muse-signup]';
  const STORE_KEY = 'muse-signup-email';
  const REVISION = '2024-10-15';
  const ENDPOINT = 'https://a.klaviyo.com/client';

  function post(path, companyId, payload) {
    return fetch(`${ENDPOINT}/${path}/?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        revision: REVISION,
      },
      body: JSON.stringify(payload),
      keepalive: true,
    }).then((response) => {
      if (response.ok) return response;
      return response.text().then((text) => {
        throw new Error(`Klaviyo ${response.status}: ${text}`);
      });
    });
  }

  function subscribe(root, email) {
    const companyId = root.dataset.klaviyoCompany;
    const listId = root.dataset.klaviyoList;
    if (!companyId || !email) return Promise.resolve();

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: root.dataset.klaviyoSource || 'Muse of Siot form',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: { 'Muse Applicant': true },
              },
            },
          },
        },
      },
    };

    if (listId) {
      payload.data.relationships = { list: { data: { type: 'list', id: listId } } };
    }

    return post('subscriptions', companyId, payload);
  }

  function attachSocial(root, email, platform, handle) {
    const companyId = root.dataset.klaviyoCompany;
    if (!companyId || !email) return Promise.reject(new Error('Missing company id or email'));

    return post('profiles', companyId, {
      data: {
        type: 'profile',
        attributes: {
          email,
          properties: {
            'Muse Applicant': true,
            'SNS Platform': platform,
            'SNS Handle': handle,
          },
        },
      },
    });
  }

  function remember(email) {
    try {
      window.sessionStorage.setItem(STORE_KEY, email);
    } catch (error) {
      /* private mode */
    }
  }

  function recall() {
    try {
      return window.sessionStorage.getItem(STORE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function watchEmail(root) {
    const form = root.querySelector('form');
    const field = root.querySelector('[data-muse-email]');
    if (!form || !field) return;

    form.addEventListener('submit', () => {
      const email = field.value.trim();
      if (!email) return;

      remember(email);
      subscribe(root, email).catch((error) => console.warn('[muse]', error));
    });
  }

  function watchSocial(root) {
    const panel = root.querySelector('[data-muse-social]');
    if (!panel) return;

    const field = panel.querySelector('[data-muse-handle]');
    const button = panel.querySelector('[data-muse-social-submit]');
    const note = panel.querySelector('[data-muse-social-message]');
    const prompt = panel.querySelector('[data-muse-prompt]');
    const choiceStep = panel.querySelector('[data-muse-choice-step]');
    const handleStep = panel.querySelector('[data-muse-handle-step]');
    if (!field || !button) return;

    const basePlaceholder = field.getAttribute('placeholder') || '';

    const named = (text, label) => text.replace(/\{platform\}/g, label).replace(/\s+/g, ' ').trim();

    panel.querySelectorAll('[data-muse-platform]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const label = (radio.nextElementSibling && radio.nextElementSibling.textContent.trim()) || '';

        if (choiceStep) choiceStep.hidden = true;
        if (handleStep) handleStep.hidden = false;
        if (prompt && prompt.dataset.handlePrompt) {
          prompt.textContent = named(prompt.dataset.handlePrompt, label);
        }
        field.setAttribute('placeholder', named(basePlaceholder, label));
        field.focus();
      });
    });

    const say = (text, failed) => {
      if (!note) return;
      note.textContent = text;
      note.classList.toggle('muse-steps__message--error', !!failed);
      note.hidden = !text;
    };

    button.addEventListener('click', () => {
      const chosen = panel.querySelector('[data-muse-platform]:checked');
      const handle = field.value.trim().replace(/^@+/, '');
      const email = recall();

      if (!chosen) return say(panel.dataset.missingPlatform, true);
      if (!handle) return say(panel.dataset.missingHandle, true);
      if (!email) return say(panel.dataset.missingEmail, true);

      button.disabled = true;
      say('');

      attachSocial(root, email, chosen.value, `@${handle}`)
        .then(() => {
          panel.hidden = true;
          const done = root.querySelector('[data-muse-done]');
          if (done) done.hidden = false;
        })
        .catch((error) => {
          console.warn('[muse]', error);
          button.disabled = false;
          say(panel.dataset.failed, true);
        });
    });
  }

  function build(root) {
    if (root.dataset.museReady) return;
    root.dataset.museReady = 'true';

    watchEmail(root);
    watchSocial(root);
  }

  function apply(scope = document) {
    scope.querySelectorAll(ROOT).forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));
})();
